/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at

 * http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const MA = 'MA'
export const EMA = 'EMA'
export const VOL = 'VOL'
export const MACD = 'MACD'
export const BOLL = 'BOLL'
export const KDJ = 'KDJ'
export const RSI = 'RSI'
export const BIAS = 'BIAS'
export const BRAR = 'BRAR'
export const CCI = 'CCI'
export const DMI = 'DMI'
export const CR = 'CR'
export const PSY = 'PSY'
export const DMA = 'DMA'
export const TRIX = 'TRIX'
export const OBV = 'OBV'
export const VR = 'VR'
export const WR = 'WR'
export const MTM = 'MTM'
export const EMV = 'EMV'
export const SAR = 'SAR'
